import { useState } from "react";
import { MessageCircle, X, Bot } from "lucide-react";
import { useChatSession } from "../hooks/useChatSession";
import { MessageList } from "./chat/MessageList";
import { ChatInput } from "./chat/ChatInput";

function ChatHeader({ onClose }) {
  return (
    <div className="flex items-center justify-between px-4 py-3 border-b border-[#2F4F4F]/20 bg-ib-surface flex-shrink-0">
      <div className="flex items-center gap-3">
        <div className="w-8 h-8 rounded-full bg-[#007BFF]/20 flex items-center justify-center">
          <Bot className="w-4 h-4 text-[#007BFF]" />
        </div>
        <div>
          <div className="font-outfit font-bold text-sm text-ib-text">Payal</div>
          <div className="flex items-center gap-1.5">
            <span className="w-1.5 h-1.5 rounded-full bg-[#CCFF00]" />
            <span className="font-jetbrains text-[10px] text-ib-text-secondary">IronByte Sales Assistant</span>
          </div>
        </div>
      </div>
      <button onClick={onClose} data-testid="chat-close-btn" className="p-1.5 rounded-lg hover:bg-[#2F4F4F]/20 text-ib-text-secondary hover:text-ib-text transition-colors">
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}

export function ChatWidget() {
  const [open, setOpen] = useState(false);
  const { messages, loading, sendMessage } = useChatSession(open);
  const toggle = () => setOpen((p) => !p);

  return (
    <div data-testid="chat-widget" className="fixed right-6 z-50 flex flex-col items-end" style={{ bottom: "calc(5rem + env(safe-area-inset-bottom))" }}>
      {open && (
        <div data-testid="chat-panel" className="w-[370px] max-w-[calc(100vw-48px)] h-[500px] max-h-[calc(100vh-100px)] mb-4 rounded-2xl border border-[#2F4F4F]/30 bg-ib-bg shadow-[0_0_60px_rgba(0,123,255,0.15)] flex flex-col overflow-hidden">
          <ChatHeader onClose={toggle} />
          <MessageList messages={messages} loading={loading} />
          <ChatInput loading={loading} onSend={sendMessage} />
        </div>
      )}
      <button onClick={toggle} data-testid="chat-toggle-btn"
        className={`w-14 h-14 rounded-full flex items-center justify-center shadow-[0_0_30px_rgba(0,123,255,0.4)] hover:shadow-[0_0_40px_rgba(0,123,255,0.6)] transition-all ${open ? "bg-[#2F4F4F] hover:bg-[#2F4F4F]/80" : "bg-[#007BFF] hover:bg-[#007BFF]/90"} text-white`}>
        {open ? <X className="w-6 h-6" /> : <MessageCircle className="w-6 h-6" />}
      </button>
    </div>
  );
}
